module.exports = __webpack_public_path__ + "img/logo-xs.48d5cf24.png";